<div class="payment-container" [class.has-no-step-bars]="payment.full_payment.full_payment_made">
	<!--  STEP HEADER  -->

	<cng-step-header *ngIf="!payment.full_payment.full_payment_made"
		[current_step_key]="current_step_key"
		[location]="'engage_configure'"
		(jump)="jumpTo($event)"
	></cng-step-header>

	<!--  END STEP HEADER  -->

	<div class="payment">
		<!--  NOT RESERVED - PAYMENT NOT ALLOWED  -->
		<div
			*ngIf="
				(max_cashback_reached && payment.reservation.reservation_date === null) ||
				(payment.reservation.reservation_date === null &&
					(payment.payment_providers === null || payment.payment_providers.length < 1))
			"
		>
			<div class="heading">
				<ui-concierge
					data-element-view="concierge__engage_configure_payment_step__[Reserve your new vehicle today!]"
				>
					<h1>Reserve your new vehicle today!</h1>

					<p>Please arrange a callback to discuss your deal with a member of our sales team.</p>

					<a
						type="button"
						class="button button-with-icon-right positive-button"
						data-element-click="button__engage_configure_payment[payment_not_allowed]__positive-button[Arrange Callback]"
						(click)="showCallback()"
					>
						<i class="icon-callback"></i>
						<span class="text">Arrange Callback</span>
					</a>
				</ui-concierge>
			</div>
		</div>

		<!--  END NOT RESERVED - CALLBACK  -->

		<!--  NOT RESERVED OR PURCHASED - PAYMENT ALLOWED  -->

		<div *ngIf="!max_cashback_reached && payment.reservation.reservation_date === null && payment.full_payment.full_payment_date === null && payment.payment_providers.length > 0">
			<div class="heading">
				<ui-concierge
					[attr.data-element-view]="
						'concierge__engage_configure_payment_step__[Reserve your new vehicle with a ' +
						(dealer.reservation && dealer.reservation.refundable ? 'refundable ' : ' ') +
						'£' +
						payment.reservation.reservation_amount +
						' reservation fee]'
					"
				>
					<h1>
						{{ buy_now_enabled ? 'Buy now or reserve' : 'Reserve' }} your new vehicle with a
						{{ dealer.reservation && dealer.reservation.refundable ? 'refundable' : '' }}
						{{ payment.reservation.reservation_amount | money: 0 }} reservation fee
					</h1>
					<p class="hidden-xxs hidden-xs">Don't let your new vehicle get away, {{buy_now_enabled ? 'buy' : 'reserve'}} today!</p>
				</ui-concierge>
			</div>

			<div *ngIf="buy_now_enabled" class="container button-payment-options-container">
				<a
					class="button"
					[ngClass]="payment_type === 'buyNow' ? 'primary-button' : 'minor-button'"
					data-element-click="tab__engage_configure_payment__[Buy Now]"
					(click)="onTogglePaymentType('buyNow')"
				>
					Buy <span class="hidden-xxs hidden-xs">Now </span>for {{grand_total | currency:'GBP':'symbol':'1.0-2'}}
				</a>
				<a
					class="button"
					[ngClass]="payment_type === 'reserve' ? 'primary-button' : 'minor-button'"
					data-element-click="tab__engage_configure_finance_options__[Cash]"
					(click)="onTogglePaymentType('reserve')"
				>
					Reserve for {{payment.reservation.reservation_amount | currency:'GBP':'symbol':'1.0-2'}}
				</a>
			</div>

			<div class="accordion checklist-accordion" [class.has-buy-now]="buy_now_enabled">
				<div *ngIf="buy_now_enabled" class="accordion-item">
					<div class="totals">
						<div class="summary-container" [class.show-summary]="show_summary">
							<div>
								<a
									class="toggle-summary"
									(click)="show_summary = !show_summary"
									data-element-click="tab__engage_configure_payment__[Show Order Summary]"
								>
									<i [ngClass]="show_summary ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
									<span class="text-hl">{{show_summary ? 'Hide' : 'Show'}} Order Summary</span>
								</a>
							</div>
							<cng-order-summary *ngIf="show_summary" [force_cash_payment]="payment_type === 'buyNow'"></cng-order-summary>
						</div>
						<div class="total-row">
							<h2 class="label">To pay now:</h2>
							<div class="value text-hl">{{(payment_type === 'buyNow' ? grand_total : payment.reservation.reservation_amount) | money}}</div>
						</div>
						<div class="total-row">
							<h2 class="label">To pay later:</h2>
							<div class="value text-hl">{{(payment_type === 'buyNow' ? 0 : (grand_total - payment.reservation.reservation_amount)) | money}}</div>
						</div>

					</div>

				</div>
				<div
					*ngFor="let provider of payment.payment_providers"
					[ngSwitch]="provider.reference"
					class="accordion-item"
					[ngClass]="{ active: provider.selected || payment.payment_providers.length === 1 }"
				>
					<!--  STRIPE PAYMENT  -->

					<ng-template [ngSwitchCase]="'stripe'">
						<div
							[attr.id]="provider.reference"
							class="accordion-item-label"
							data-element-click="payment_option__engage_configure_payment__[Stripe]"
							(click)="onAccordionChange(provider)"
						>
							<h2>
								<i
									*ngIf="payment.payment_providers.length !== 1"
									class="icon-tick checkbox"
									[class.checked]="provider.selected"
								></i>
								Card Payment
							</h2>
							<div class="logos">
								<a href="https://stripe.com/gb" target="_blank">
									<img [src]="stripe_logo" alt="Stripe" />
								</a>
								<img class="img-visa" [src]="visa_logo" alt="VISA" />
								<img class="img-mastercard" [src]="mastercard_logo" alt="Mastercard" />
							</div>
						</div>

						<div class="accordion-item-content">
							<cng-stripe [key]="provider.key" [test_mode]="provider.test_mode" [payment_type]="payment_type"></cng-stripe>
						</div>
					</ng-template>

					<!--  END STRIPE PAYMENT  -->

					<!--  PAYMENT SENSE PAYMENT  -->

					<ng-template [ngSwitchCase]="'payment-sense'">
						<div
							[attr.id]="provider.reference"
							class="accordion-item-label"
							data-element-click="payment_option__engage_configure_payment__[Payment Sense]"
							(click)="onAccordionChange(provider)"
						>
							<h2>
								<i
									*ngIf="payment.payment_providers.length !== 1"
									class="icon-tick checkbox"
									[class.checked]="provider.selected"
								></i>
								Card Payment
							</h2>
							<div class="logos">
								<a href="https://paymentsense.com" target="_blank">
									<img [src]="payment_sense_logo" alt="PaymentSense" />
								</a>
								<img class="img-visa" [src]="visa_logo" alt="VISA" />
								<img class="img-mastercard" [src]="mastercard_logo" alt="Mastercard" />
							</div>
						</div>

						<div class="accordion-item-content">
							<cng-payment-sense
								[key]="provider.key"
								[test_mode]="provider.test_mode"
								[payment_type]="payment_type"
							></cng-payment-sense>
						</div>
					</ng-template>

					<!--  END PAYMENT SENSE PAYMENT  -->

					<!-- TELEPHONE PAYMENT  -->

					<ng-template [ngSwitchCase]="'telephone'">
						<div id="telephone-payment-container">
							<div
								[attr.id]="provider.reference"
								class="accordion-item-label"
								data-element-click="payment_option__engage_configure_payment__[Telephone Payment]"
								(click)="onAccordionChange(provider)"
							>
								<h2>
									<i
										*ngIf="payment.payment_providers.length !== 1"
										class="icon-tick checkbox"
										[class.checked]="provider.selected"
									></i>
									Telephone Payment
								</h2>
							</div>

							<div class="accordion-item-content">
								<cng-telephone-payment></cng-telephone-payment>
							</div>
						</div>
					</ng-template>

					<!-- END TELEPHONE PAYMENT  -->
				</div>
			</div>
		</div>

		<!--  END NOT RESERVED - PAYMENT ALLOWED  -->

		<!--  RESERVED  -->

		<div *ngIf="payment.reservation.reservation_date !== null">
			<div class="heading">
				<ui-concierge data-element-view="concierge__engage_configure_payment_step__[Hooray, it's reserved!]">
					<h1>Hooray, it's reserved!</h1>

					<p class="concierge-reservation-amount">
						<span class="sec-bg sec-fg"><i class="icon-tick"></i></span>
						{{ payment.reservation.reservation_amount | money }} reservation fee paid.
					</p>

					<p>Your vehicle is reserved and will soon be ready for you to drive away.</p>

					<p class="margin-top-0">
						Arrange a callback to organise collection or delivery of your new vehicle and discuss the next
						steps with our team.
					</p>
					<a
						type="button"
						class="button button-with-icon-right positive-button"
						data-element-click="button__engage_configure_payment[reserved]__positive-button[Arrange Callback]"
						(click)="showCallback()"
					>
						<i class="icon-callback"></i>
						<span class="text">Arrange Callback</span>
					</a>
				</ui-concierge>
			</div>
		</div>

		<!--  END RESERVED  -->

		<!--  FULL PAYMENT MADE  -->

		<div *ngIf="payment.full_payment.full_payment_made">
			<div class="heading">
				<ui-concierge data-element-view="concierge__engage_configure_payment_step__[Hooray, it's yours!]">
					<h1>Thanks for your purchase!</h1>

					<p class="concierge-reservation-amount">
						<span class="sec-bg sec-fg"><i class="icon-tick"></i></span>
						You paid {{ payment.full_payment.full_payment_amount | money }}.
					</p>

					<p>Your vehicle will soon be ready for you to drive away.</p>

					<p class="margin-top-0">
						Contact us to organise collection or delivery of your new vehicle and discuss the next
						steps with our team.
					</p>
					<a
					type="button"
					class="button positive-button"
					data-element-click="button__engage_configure_payment[full_payment]__positive-button[Contact Us]"
					(click)="onShowContact()"
				>
					<span class="text">Contact Us</span>
				</a>

				</ui-concierge>
			</div>

			<div class="confirmed-summary-container">
				<h2>Order Summary</h2>
				<cng-order-summary show_totals="true" [force_cash_payment]="true"></cng-order-summary>
			</div>

		</div>

		<!--  END FULL PAYMENT MADE  -->
	</div>

	<!--  STEP BAR  -->

	<cng-step-bar *ngIf="!payment.full_payment.full_payment_made" [show_next]="false" [current_step_key]="current_step_key" (jump)="jumpTo($event)"></cng-step-bar>

	<!--  END STEP BAR -->

	<!-- SCROLL FADES  -->

	<div *ngIf="!payment.full_payment.full_payment_made" class="scroll-fade top"></div>
	<div *ngIf="!payment.full_payment.full_payment_made" class="scroll-fade bottom"></div>

	<!--  END SCROLL FADES  -->
</div>
